module.exports = __webpack_public_path__ + "static/img/nophoto.58f16fcf.gif";